"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get3 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _ReduxForm = _interopRequireDefault(require("angieslist-react-components/lib/ReduxForm"));
var _ReduxFormPhoneNumber = _interopRequireDefault(require("angieslist-react-components/lib/ReduxFormPhoneNumber"));
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));
var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));
var _Input = _interopRequireDefault(require("angieslist-react-components/lib/Input"));
var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));
var _Modal = _interopRequireDefault(require("angieslist-react-components/lib/Modal"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _propTypes = _interopRequireDefault(require("prop-types"));
var memberMgmtActions = _interopRequireWildcard(require("../../../../actions/memberMgmtGatewayActions"));
var myAccountUIActions = _interopRequireWildcard(require("../../../../actions/myAccountUIActions"));
var _personalDetails = require("../../../../validations/personalDetails");
var _requiredTextLabel = require("../../requiredTextLabel");
var _getErrorMessage = _interopRequireDefault(require("angieslist-app-platform/lib/common/getErrorMessage"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var submit = function submit(updateUser, values, userId, updatePersonalDetails, handleClose) {
  var personalDetails = {
    userId: Number(userId),
    firstName: values.firstName,
    lastName: values.lastName,
    contactInformation: {
      primaryPhoneNumber: values.primaryPhoneNumber,
      mobilePhoneNumber: values.mobilePhoneNumber
    }
  };
  updateUser(personalDetails).then(function () {
    updatePersonalDetails(personalDetails);
    handleClose();
  });
};
var PersonalDetailsModal = function PersonalDetailsModal(_ref) {
  var _ref$user = _ref.user,
    userId = _ref$user.userId,
    email = _ref$user.email,
    dirty = _ref.dirty,
    pristine = _ref.pristine,
    invalid = _ref.invalid,
    editButtonStyle = _ref.editButtonStyle,
    handleSubmit = _ref.handleSubmit,
    memberManagementGateway = _ref.memberManagementGateway,
    updateUser = _ref.updateUser,
    updatePersonalDetails = _ref.updatePersonalDetails,
    showModal = _ref.showModal,
    handleClose = _ref.handleClose;
  var _get2 = (0, _get3["default"])(memberManagementGateway, 'updateUser'),
    isUpdateUserLoading = _get2.isLoading,
    updateUserError = _get2.error;
  var errorMessage = (0, _getErrorMessage["default"])(updateUserError);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    show: showModal,
    onHide: handleClose,
    backdrop: "static",
    id: "personal-details-modal"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Header, {
    closeButton: true
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Title, null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "modal-title"
  }, "Edit Personal Details"))), /*#__PURE__*/_react["default"].createElement("form", {
    name: "edit-personal-details",
    onSubmit: handleSubmit(function (values) {
      submit(updateUser, values, userId, updatePersonalDetails, handleClose);
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-body"
  }, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    type: "static",
    value: email,
    label: "Email Address:"
  }), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "firstName",
    type: "text",
    label: (0, _requiredTextLabel.markRequiredText)('First Name:'),
    id: "personal-details-modal--first-name"
  })), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_ReduxForm["default"].Input, {
    name: "lastName",
    type: "text",
    label: (0, _requiredTextLabel.markRequiredText)('Last Name:'),
    id: "personal-details-modal--last-name"
  }))), /*#__PURE__*/_react["default"].createElement(_Row["default"], null, /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_ReduxFormPhoneNumber["default"], {
    name: "primaryPhoneNumber",
    label: "Home Phone:",
    id: "personal-details-modal--home-phone"
  })), /*#__PURE__*/_react["default"].createElement(_Col["default"], {
    xs: 12,
    sm: 6
  }, /*#__PURE__*/_react["default"].createElement(_ReduxFormPhoneNumber["default"], {
    name: "mobilePhoneNumber",
    label: "Mobile Phone:",
    id: "personal-details-modal--mobile-phone"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-footer"
  }, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "personal-details-modal--save-button",
    flat: true,
    bsStyle: editButtonStyle,
    disabled: pristine || invalid || isUpdateUserLoading,
    loading: isUpdateUserLoading,
    bsSize: "small",
    type: "submit"
  }, "Save")), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "personal-details-modal--close-button",
    flat: true,
    bsSize: "small",
    bsStyle: "tertiary",
    onClick: handleClose
  }, "Cancel")))));
};

// Prop Types
PersonalDetailsModal.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  memberManagementGateway: _propTypes["default"].object,
  updateUser: _propTypes["default"].func.isRequired,
  updatePersonalDetails: _propTypes["default"].func.isRequired,
  // redux store
  user: _propTypes["default"].shape({
    userId: _propTypes["default"].number.isRequired,
    email: _propTypes["default"].string.isRequired,
    firstName: _propTypes["default"].string,
    lastName: _propTypes["default"].string,
    primaryContactInformation: _propTypes["default"].shape({
      primaryPhoneNumber: _propTypes["default"].string,
      mobilePhoneNumber: _propTypes["default"].string
    })
  }),
  // redux form
  dirty: _propTypes["default"].bool.isRequired,
  pristine: _propTypes["default"].bool.isRequired,
  invalid: _propTypes["default"].bool.isRequired,
  reset: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  handleClose: _propTypes["default"].func.isRequired,
  showModal: _propTypes["default"].bool.isRequired
};
var PersonalDetailsModalReduxForm = (0, _reduxForm.reduxForm)({
  form: 'edit-personal-details',
  validate: function validate(values) {
    return _angieslistAppPlatform.validation.validate(values, _personalDetails.personalDetailsValidationRules).invalidAttrs;
  }
})(PersonalDetailsModal);
var _default = exports["default"] = (0, _compose["default"])((0, _reactRedux.connect)(function (state, props) {
  return {
    memberManagementGateway: state.memberManagementGateway,
    initialValues: {
      firstName: props.user.firstName,
      lastName: props.user.lastName,
      primaryPhoneNumber: (0, _get3["default"])(props, 'user.primaryContactInformation.primaryPhoneNumber'),
      mobilePhoneNumber: (0, _get3["default"])(props, 'user.primaryContactInformation.mobilePhoneNumber')
    }
  };
}, _objectSpread(_objectSpread({}, memberMgmtActions), myAccountUIActions)), _pure["default"])(PersonalDetailsModalReduxForm);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/myAccount/modals/personalDetailsModal.js
// module id = 4251
// module chunks = 9